import { NgModule } from '@angular/core';
import { HomeVerticalLayoutModule } from './home/vertical-layout/home-vertical-layout.module';

@NgModule({
    imports: [
        HomeVerticalLayoutModule
    ],
    exports: [
        HomeVerticalLayoutModule
    ]
})
export class HomeLayoutModule {
}
